import type { Requisition } from '../../types/types'
import { FinalizeSample } from './FinalizeSample'
import { ModalDialog, Mtds } from 'prove-common'

type FinalizeSampleModalProps = {
  requisition: Requisition
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
  isEdit?: boolean
}

export const FinalizeSampleModal = ({
  requisition,
  isOpen,
  setOpen,
  isEdit
}: FinalizeSampleModalProps) => (
  <ModalDialog
    id='finalize-sample-modal'
    closedby='any'
    onClose={() => setOpen(false)}
    open={isOpen}
    data-color={'main'}
  >
    <Mtds.Button
      command='close'
      commandfor='finalize-sample-modal'
      aria-label={'Lukk'}
    />
    <Mtds.Prose>
      <Mtds.Heading>
        {isEdit ? 'Rediger oppfølging' : 'Ferdigstill og avskriv'}
      </Mtds.Heading>
      {!isEdit && (
        <p>
          Avskriv betyr å avslutte saken i arkivet. Når prøven ferdigstilles,
          blir saken oppdatert i arkivet.
        </p>
      )}
      <FinalizeSample
        requisition={requisition}
        onFinalizedSuccess={() => {
          setOpen(false)
        }}
        onCanceled={() => setOpen(false)}
        isEdit={isEdit}
      />
    </Mtds.Prose>
  </ModalDialog>
)
